

export function CollapseSvg({ color, height = 21, width = 20 }) {
    return <svg width={width} height={height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M16.125 5.5L18 7.39873L10 15.5L2 7.39873L3.875 5.5L10 11.7025L16.125 5.5Z" fill="#5865F2"/>
    </svg>      
}

export default CollapseSvg;
